<template>
  <router-view />
</template>
<script>
  export default {
    name: 'RelatorioModule',
  }
</script>
